/**
 * Author: Hiroki Moto
 * Updated at 02/26/2020
 */

import React, { memo } from 'react';
import PropTypes from 'prop-types';
import length from 'ramda/src/length';
import * as ProgramsList from '@components/LibraryProgramsList';

function List(props) {
    const { data, role, dataCy } = props;

    return (
        <>
            {data.map((item, index) => (
                <ProgramsList.ClosedList
                    key={`${item.id}-${index}`}
                    dataCy={dataCy + index}
                    role={role}
                    name={item.name}
                    published={item.published}
                    description={`Habits: ${length(item.children)}`}
                    type="habitslist"
                    modules={item.data.assigned}
                    onToggle={() => props.onToggle(item.id)}
                    onChange={(e) => props.onSelect(e, item)}
                />
            ))}
        </>
    );
}

List.propTypes = {
    data: PropTypes.array,
    onToggle: PropTypes.func,
};

List.defaultProps = {
    data: [],
    onSelect: () => {},
    onToggle: () => {},
};

export default memo(List);
